export class SelectOption {
    label: string;
    value: string;
}